export default "__VITE_ASSET__BThndtCj__"